<template>
  <div class="base-layout">
    <div class="base-layout__header">
      <nav class="base-layout__menu">
        <div class="searchBox">
          <div class="search-item">
            <div class="left-login">
              <div class="tag" v-if="!store.token" @click="toLogin">校友登录</div>
              <Tooltip v-else placement="bottom">
                <div class="tag red" @click="onLogout">
                  {{ store.realName }}
                </div>
                <template slot="title">
                  <span>点击退出登录</span>
                </template>
              </Tooltip>
            </div>
            <div class="right-search">
              <Input
                type="search"
                v-model="searchValue"
                placeholder="站内搜索"
                style="width: 200px; height: 30px"
                @keyup.enter="gotoSearch"
              />
              <Button style="margin-left: 3px; height: 30px" type="primary" @click="gotoSearch">搜索</Button>
            </div>
          </div>
        </div>
        <NavTop />
      </nav>
    </div>
    <NavPanel />

    <div class="base-layout__main">
      <router-view></router-view>
    </div>
    <BackTop />

    <div class="base-layout__footer">
      <Footer />
    </div>
  </div>
</template>

<script setup>
import NavTop from './NavTop.vue'
import Footer from './Footer.vue'
import NavPanel from '@/components/NavPanel.vue'
import { BackTop, Input, Button, Tooltip } from 'ant-design-vue'
import { ref } from 'vue'
import { useRoute, useRouter } from '@/hooks/useRouter'
import { useAppStore } from '@/store/app'

const router = useRouter()
const searchValue = ref('')

const store = useAppStore()

function gotoSearch() {
  if (!searchValue.value) return
  // router.push({
  //   path: `/searchPage/index?value=${searchValue.value}`,
  // })
  window.open(`/#/searchPage/index?value=${searchValue.value}`, '_blank')
}

function toLogin() {
  router.replace('/user/login')
}
function onLogout() {
  store.removeToken()
  window.location.reload()
}
</script>

<style lang="less" scoped>
.base-layout {
  height: 100%;
  background-color: #fff;

  &__header {
    background-color: @primary;
    padding-top: 10px;
  }

  &__menu {
    background-color: #fff;
    border-bottom: 1px solid #ebebeb;

    .searchBox {
      height: 40px;
      border-bottom: 1px solid #ebebeb;

      .search-item {
        position: relative;
        z-index: 20;
        height: 100%;
        max-width: 1200px;
        margin: auto;
      }
      .left-login {
        float: left;
        display: flex;
        align-items: center;
        height: 100%;
        .tag {
          color: @primary;
          font-size: 12px;
          padding: 6px 13px;
          border-radius: 15px;
          border: 1px solid @primary;
          cursor: pointer;
          transition: all 0.2s;
          &:hover {
            color: #fff;
            background-color: @primary;
          }
          &.red {
            color: @danger;
            border: 1px solid @danger;
            &:hover {
              color: #fff;
              background-color: @danger;
            }
          }
        }
      }

      .right-search {
        display: flex;
        align-items: center;
        float: right;
        height: 100%;
      }
    }
  }

  &__main {
    min-height: calc(100% - 45px - 48px);
    // padding: 16px;
    // overflow: auto;
  }

  &__footer {
    margin-top: 16px;
    color: #c3c3c3;
    font-size: 12px;
    text-align: center;
    border-top: 1px solid #eee;
  }
}
</style>
